import InformationCard from "@components/information_card/information_card"
import store from "../../store/store"
import modalStore from '../../store/modal_measurements/store'
import stationHelper from "../../helpers/station_helper"
import MeasurementsListComponent from "./components/measurements_list"
import Gate from "./components/gate"
import helpers from "./helpers"
import Chart from "./components/chart"
import dam_helper from "../../helpers/dam_helper"
import general_helper from "../../helpers/general_helper"
import('./information_card.css')

export default function InformationCardComponent(opts={}){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this
    let current_gates = {}
    let current_station_id = undefined
    let IS_MOBILE = general_helper.isMobile()
    let informationCard, measurementsListComponent,chartComponent 

    this.generate = () =>{
        
        informationCard = new InformationCard({size:(!IS_MOBILE ? 'lg' : 'full')})
        informationCard.generateCard()

        // measurementsListComponent = new MeasurementsListComponent({measurements:[]})
        chartComponent = new Chart({container: informationCard.getContentContainer()})
        chartComponent.generate()

        chartComponent.on('seemore-button-click', station =>{
            //informando a estação que esta 'selecionada' para abertura do modal (modal abrindo sempre que for atualizada para uma estação valida)
            modalStore.setStation(station)
        })
        
        eventsHandler()
    }

    this.update = () =>{

    }

    const eventsHandler = _ =>{
        store.informationCardStore.subscribe('SET_STATION_ID', data=>{
            if(data.obj_id){
                current_station_id = data.obj_id
                if(stationHelper.loading_stations){
                    informationCard.updateCard({title: 'Carregando...', subtitle: '', text: ''})
                } else {
                    updateCardInfo(current_station_id)
                    informationCard.show()
                }
                
            } else {
                chartComponent.destroy()
                informationCard.hide()
            }
        })
        store.informationCardStore.subscribe('UPDATE_CARD_POSITION', data=>{
            if(!IS_MOBILE){
                informationCard.updatePosition(data.el)
            } else {
                informationCard.updatePosition('center')
            }
            
        })
    }

    const updateCardInfo = (obj_id) =>{
        let obj_type = store.informationCardStore.getObjType()
        
        if(obj_type == 'station'){

            //obj_id pode ser um array de ids (grupo de plus) ou um id em especifico
            let station = Array.isArray(obj_id) ? store.stationStore.getStationsByIds(obj_id) : store.stationStore.getStation(obj_id)

            //caso seja exista, mas n seja um array, é um posto único
            if(station && !Array.isArray(station)){

                //atualizando cabeçalho do chart
                informationCard.updateCard({title:station.prefix, subtitle: `${station.station.name}<br><div class='font-size-xs'>${station.station.latitude},${station.station.longitude}</div>`})

                //atualizando status do card
                updateCardText(station)

                //atualizando/criando chart caso posto possua medições
                if(station.measurements && station.measurements.length > 0){
                    //atualizando/criando chart
                    chartComponent.update(station)
                } 
            //caso exista e não tenha entrada como posto único, é múltiplo
            } else if(station){      
                //removendo chart
                chartComponent.destroy()

                informationCard.updateCard({title:store.informationCardStore.getTitle(), subtitle: station.map(x=>x.station.name).join(',')})

                //pegando todas as medições de todos os postos
                let all_measurements = station.reduce((a, c) => c.measurements && Array.isArray(c.measurements) ?  [...a, ...c.measurements] : a, [])

                if(all_measurements.length > 0){
                    //caso tenha alguma medição, criar/atualizar o gráfico
                    chartComponent.update(station)
                }
                
            }  else{
                //destruindo chart
                chartComponent.destroy()

                //ponto sem informações
                informationCard.updateCard({title: 'Sem informações adicionais', subtitle: '', text: ''})
            }
        } else if(obj_type == 'dam'){
            //removendo chart
            chartComponent.destroy()
            
            //pegando informações da dam
            let dam = store.damStore.getDam(obj_id)

            if(dam){
                //atualizando corpo do card com a viewDam
                informationCard.updateCard({title: dam.name, subtitle: setDamSubtitle(obj_id), text: setDamContent(dam, obj_id)})
            } else {
                informationCard.updateCard({title: 'Sem informações adicionais', subtitle: '', text: ''})
            }

            
        } else if(obj_type === 'tankdam'){
            //removendo chart
            chartComponent.destroy()

            //pegando informações da dam
            let dam = store.damStore.getDam(obj_id)

            //atualizando corpo do card com a viewDam
            informationCard.updateCard({title: dam.name, subtitle: '', text: ''})
        }
    }

    const setDamSubtitle = dam_id =>{
        //ou é a lista de comportas do ultimo evento (atualização) ou é as comportas padrões
        let floodgates = dam_helper.getDamGates(dam_id) || dam_helper.getDamDefaultGates(dam_id)

        return (floodgates) ? `${Object.values(floodgates).filter(x=>x.status == 'true' || x.status == true).length}/${Object.keys(floodgates).length} comportas abertas` : ''
    }

    const setDamContent = (dam, dam_id) =>{
        //ou é a lista de comportas do ultimo evento (atualização) ou é as comportas padrões
        let floodgates = dam_helper.getDamGates(dam_id) || dam_helper.getDamDefaultGates(dam_id)

        let container = context.createElement('div', '', '')
        let show_floodgates = false
        current_gates=[]
        
        if(floodgates){
            show_floodgates = true //just for help
            let el_container = context.createElement('div', 'flex flex flex-h-space-around flex-gap-xs', '')
            let save_button_container = context.createElement('div', 'mt-2', '')
            
            $.each(floodgates, (gate_id,gate) =>{
                let _gate = new Gate({gate: gate, container: el_container})
                _gate.generate()
                
                current_gates.push({status: gate.status,id:gate.id})
                
                if(CAN_EDIT_PENHA){
                    _gate.on('click', status =>{                    
                        current_gates.find(x=>x.id === gate.id).status = status
                    })
                }
                
            })

            if(CAN_EDIT_PENHA){
                let el_button = context.createElement('button', '', 'Salvar')
            
                $(el_button).on('click', _=>{
                    
                    dam_helper.saveDamGates(dam_id, current_gates)
                })

                $(save_button_container).append(el_button)
            }

            $(container).append(el_container,save_button_container)
        } 

        if(dam.flow_station){//tem posto para relacionado para calculo de vazão (caso tenha curva chave)
            let current_flow_container = context.createElement('div', 'mt-2', '')
            let loading = store.equationStore.isLoading()
            if(!loading){
                let equations = store.equationStore.equationsFromStation(parseInt(dam.flow_station))
                if(equations.length > 0){
                    let gate_flow = helpers.calculateFlow(equations, dam, show_floodgates, 'gate') //vazao de uma comporta
                    let open_gates = Object.values(floodgates).filter(x=>x.status === 'true' || x.status === true)
                    if(gate_flow){
                        current_flow_container.innerHTML = `<div>Vazão atual: ${gate_flow*open_gates.length}</div>`
                    } else {
                        current_flow_container.innerHTML = `<div>Não foi possivel calcular vazão</div>`
                    }
                    
                } else {
                    current_flow_container.innerHTML = `Posto sem equações de vazão`
                }
                
            } else {
                current_flow_container.innerHTML = 'carregando equações'
            }
            
            $(container).append(current_flow_container)
        }

        return container

        
    }

    const updateCardText = station =>{
        if(station.measurements && station.measurements.length > 0){
            informationCard.updateTitle(`${station.prefix}${station.delay_status ? `<div class='information-card-measurement-status ${station.delay_status === 'ATRASADO' ? 'delay' : station.delay_status === 'AGUARDANDO' ? 'waiting' : ''}'>${station.delay_status === 'AGUARDANDO' ? 'AGUARDANDO DADO' : station.delay_status}</div>` : '' }`)
        } else {
            informationCard.updateText("<div style='text-align:center'>SEM MEDIÇÕES</div>")
        }
    }
}

InformationCardComponent.prototype = Object.create(BaseConstructor.prototype)